module.exports = __webpack_public_path__ + "static/media/jti-header-logo.7f0edc85.svg";